const styles = (theme) => ({
  Container: {
    padding: '0 0 8px 0',
  },
  FormItem: {
    width: '48%',
    padding: '0 0 16px 0',
    '& fieldset': {
      padding: '0px',
      margin: '0px',
      border: '0px',
    },
  },
  FormItemDisableBorder: {
    '& :hover': {
      borderColor: theme.palette.xpl.stoke,
    },
  },
  Checkbox: {
    accentColor: theme.palette.xpl.secondary.default,
    width: '16px',
    height: '16px',
    verticalAlign: 'middle',
    borderRadius: '4px',
  },
  Label: {
    fontWeight: '400',
    fontSize: '12px',
    padding: '0 0 0 9px',
    verticalAlign: 'middle',
    color: theme.palette.common.darkerText,
  },
  Select: {
    '& div[class$="control"]': {
      height: '40px',
    },
  },
});

export default styles;
